import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {GetDetalleOficio, GetGiro, PutOficios,GetPGIR,POSTPGIR,UPDCartilla, UPDPreregistro} from '../../services/SecurityService'
import {Modal,Button} from 'react-bootstrap'

import { DropdownList } from 'react-widgets';
import EmisorIcon from '@material-ui/icons/AccountBoxRounded';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';



export default class DatosOficio extends Component {
  constructor(props) {
    super(props);
    this.onChangenombre = this.onChangenombre.bind(this);
this.onChangedomicilio = this.onChangedomicilio.bind(this);
this.onChangetelefono = this.onChangetelefono.bind(this);
this.onChangeFechaRegistro = this.onChangeFechaRegistro.bind(this);
this.onChangeNoFolio = this.onChangeNoFolio.bind(this);
this.onChangeNoOficio = this.onChangeNoOficio.bind(this);
this.onChangeEstatusActual = this.onChangeEstatusActual.bind(this);
this.onChangeAsuntos = this.onChangeEstatusActual.bind(this);
this.onChangeObservaciones = this.onChangeObservaciones.bind(this);
this.onChangeEmisor = this.onChangeEmisor.bind(this);

this.onChangeGiro = this.onChangeGiro.bind(this);
this.onSubmit = this.onSubmit.bind(this);

this.onChangeNoFolio = this.onChangeNoFolio.bind(this);
this.onChangeNoOficio = this.onChangeNoOficio.bind(this);
this.onChangeFechaDocumento = this.onChangeFechaDocumento.bind(this);
this.onChangeFechaExpiracion = this.onChangeFechaExpiracion.bind(this);

this.onChangePersona = this.onChangePersona.bind(this);
this.onChangenombre = this.onChangenombre.bind(this);
this.onChangetelefono = this.onChangetelefono.bind(this);
this.onChangedomicilio = this.onChangedomicilio.bind(this);
this.onChangerfc = this.onChangerfc.bind(this);
this.onChangecorreo = this.onChangecorreo.bind(this);
this.onChangeapoderado = this.onChangeapoderado.bind(this);
this.onChangecalle = this.onChangecalle.bind(this);
this.onChangeno = this.onChangeno.bind(this);
this.onChangecolonia = this.onChangecolonia.bind(this);
this.onChangecodigoPostal = this.onChangecodigoPostal.bind(this);
this.onChangelocalidad = this.onChangelocalidad.bind(this);
this.onChangeentreCalle = this.onChangeentreCalle.bind(this);
this.onChangeyCalle = this.onChangeyCalle.bind(this);
this.onChangeinversion = this.onChangeinversion.bind(this);
this.onChangeobservaciones = this.onChangeobservaciones.bind(this);
this.onChangedenominacionComercial = this.onChangedenominacionComercial.bind(this);
this.onChangetipoEstablecimiento = this.onChangetipoEstablecimiento.bind(this);

this.onChangemedidas = this.onChangemedidas.bind(this);
this.onChangeAforo = this.onChangeAforo.bind(this);
this.onChangerazonsocial = this.onChangerazonsocial.bind(this);
this.onChangeclavecatastral = this.onChangeclavecatastral.bind(this);


this.onChangeemp_recolectora = this.onChangeemp_recolectora.bind(this);
this.onChangerazons_recolector = this.onChangerazons_recolector.bind(this);
this.onChangeticket_recolector = this.onChangeticket_recolector.bind(this);
this.onChangepapel_dia = this.onChangepapel_dia.bind(this);
this.onChangepapel_sem = this.onChangepapel_sem.bind(this);
this.onChangepapel_mes = this.onChangepapel_mes.bind(this);
this.onChangeplastico_dia = this.onChangeplastico_dia.bind(this);
this.onChangeplastico_sem = this.onChangeplastico_sem.bind(this);
this.onChangeplastico_mes = this.onChangeplastico_mes.bind(this);
this.onChangevidrio_dia = this.onChangevidrio_dia.bind(this);
this.onChangevidrio_sem = this.onChangevidrio_sem.bind(this);
this.onChangevidrio_mes = this.onChangevidrio_mes.bind(this);
this.onChangecarton_dia = this.onChangecarton_dia.bind(this);
this.onChangecarton_sem = this.onChangecarton_sem.bind(this);
this.onChangecarton_mes = this.onChangecarton_mes.bind(this);
this.onChangeorganico_dia = this.onChangeorganico_dia.bind(this);
this.onChangeorganico_sem = this.onChangeorganico_sem.bind(this);
this.onChangeorganico_mes = this.onChangeorganico_mes.bind(this);
this.onChangeotros_dia = this.onChangeotros_dia.bind(this);
this.onChangeotros_sem = this.onChangeotros_sem.bind(this);
this.onChangeotros_mes = this.onChangeotros_mes.bind(this);

this.onChangeob_papel = this.onChangeob_papel.bind(this);
this.onChangeob_plastico = this.onChangeob_plastico.bind(this);
this.onChangeob_vidrio = this.onChangeob_vidrio.bind(this);
this.onChangeob_carton = this.onChangeob_carton.bind(this);
this.onChangeob_organico = this.onChangeob_organico.bind(this);
this.onChangeob_otros = this.onChangeob_otros.bind(this);

this.onChangeCMatricula = this.onChangeCMatricula.bind(this);
this.onChangeCApellidoPaterno = this.onChangeCApellidoPaterno.bind(this);
this.onChangeCApellidoMaterno = this.onChangeCApellidoMaterno.bind(this);
this.onChangeCNombre = this.onChangeCNombre.bind(this);
this.onChangeCFechaNacimiento = this.onChangeCFechaNacimiento.bind(this);
this.onChangeCClase = this.onChangeCClase.bind(this);
this.onChangeCLugarNacimiento = this.onChangeCLugarNacimiento.bind(this);

this.onChangeCNombrePadre = this.onChangeCNombrePadre.bind(this);

this.onChangeCNombreMadre = this.onChangeCNombreMadre.bind(this);
this.onChangeCTutor = this.onChangeCTutor.bind(this);
this.onChangeCEstadoCivil = this.onChangeCEstadoCivil.bind(this);
this.onChangeCOcupacion = this.onChangeCOcupacion.bind(this);
this.onChangeCLeerEscribir = this.onChangeCLeerEscribir.bind(this);
this.onChangeCCurp = this.onChangeCCurp.bind(this);
this.onChangeCNivelEstudios = this.onChangeCNivelEstudios.bind(this);
this.onChangeCGradoMaximo = this.onChangeCGradoMaximo.bind(this);
this.onChangeCDomicilio = this.onChangeCDomicilio.bind(this);
this.onChangeCFechaEntrega = this.onChangeCFechaEntrega.bind(this);
this.onChangeCFechaRegistro = this.onChangeCFechaRegistro.bind(this);


//this.onChangenombreNegocio = this.onChangenombreNegocio.bind(this);
//this.onChangetelefonoNegocio = this.onChangetelefonoNegocio.bind(this);

this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

    this.state = {
      value: '',
      FechaRegistro: '',
      
      show: false,
      Categorias :[{descripcion : "SOLTERO", id :0},
      {descripcion : "CASADO", id :7},
      {descripcion : "DIVORCIADO", id :8},
      {descripcion : "VIUDO", id :9},
    ],
      NoFolio: '',
      nombre:'',
      domicilio:'',
      telefono:'',
      NoOficio: '',
      EstatusActual: '',
      Asuntos:'',
      Observaciones:'',
      Emisor:'',
      RD : "",
      Personas : "",
      Persona : "",
      id_oficio: "",
      Giro : [],
      value3 : "",
      Categoria : "",
      inversion:  "",
      rfc: "",
      calle: "",
      no: "",
      colonia: "",
      codigoPostal: "",
      localidad: "",
      entreCalle: "",
      yCalle: "",
      denominacionComercial: "",
      tipoEstablecimiento: "",
      apoderado : "",
      correo : "",
      FechaExpiracion: "",
      longitud:0,
      latitud:0,
      area:'',
      medidas:'',
      Aforo:'',
      razonsocial:'',
      clavecatastral:'',
      //nombreNegocio:'',
      //telefonoNegocio:'',

      address: '',
      city: '',
      area: '',
      state: '',
      zoom: 19,
      height: 400,
      mapPosition: {
          lat: 0,
          lng: 0,
      },
      markerPosition: {
          lat: 0,
          lng: 0,
      },

      emp_recolectora:'',
       ticket_recolector:'',
      razons_recolector:'',
  papel_dia:'',
  papel_sem:'',
  papel_mes:'',
  plastico_dia:'',
  plastico_sem:'',
  plastico_mes:'',
  vidrio_dia:'',
  vidrio_sem:'',
  vidrio_mes:'',
  carton_dia:'',
  carton_sem:'',
  carton_mes:'',
  organico_dia:'',
  organico_sem:'',
  organico_mes:'',
  otros_dia:'',
  otros_sem:'',
  otros_mes:'',
  ob_papel:'',
  ob_plastico:'',
  ob_vidrio:'',
  ob_carton:'',
  ob_organico:'',
  ob_otros:'',

  CMatricula:'',
      CApellidoPaterno:'',
      CApellidoMaterno:'',
      CNombre:'',
      CFechaNacimiento:'',
      CClase:'',
      CLugarNacimiento:'',
      CNombrePadre:'',
      CNombreMadre:'',
      CTutor:'',
      CEstadoCivil:'',
      COcupacion:'',
      CLeerEscribir:'',
      CCurp:'',
      CNivelEstudios:'',
      CGradoMaximo:'',
      CDomicilio:'',
      CFechaEntrega:'',
      CFechaRegistro:'',


      nivelE :['SIN ESTUDIOS',
      'PREESCOLAR',
      'PRIMARIA',
      'SECUNDARIA',
      'BACHILLERATO',
      'LICENCIATURA','INGENIERÍA','TEC SUP UNIVER',
      'POSGRADO'
    ],

    oE:[
      'ESTUDIANTE','EMPLEADO'
    ]
       
    
    }
  }
  handleClose() {
    this.setState({ show: false });
  }
  
  handleShow() {
    this.setState({ show: true });
  }

  
  componentDidMount(){
    let objj =this.props.obj;

      this.setState({ 
      value3 : {GIRO:objj.giros},
      value : {descripcion:objj.estado_civil},
     
      CMatricula: objj.matricula,
      CApellidoPaterno:objj.ap_paterno,
      CApellidoMaterno:objj.ap_materno,
      CNombre:objj.nombre,
      CFechaNacimiento:objj.fecha_nac,
      CClase:objj.clase,
      CLugarNacimiento:objj.lugar_nac,
      CNombrePadre:objj.nombre_padre,
      CNombreMadre:objj.nombre_madre,
      CTutor:objj.tutor,
      CEstadoCivil:objj.estado_civil,
      COcupacion:objj.ocupacion,
      CLeerEscribir:objj.leer_escribir,
      CCurp:objj.CURP,
      CNivelEstudios:objj.nivel_estudios,
      CGradoMaximo:objj.grado,
      CDomicilio:objj.domicilio,
      CFechaEntrega:objj.fecha_entrega,
      CFechaRegistro:objj.fecha_reg,

      
      
      //nombreNegocio:'',
      //telefonoNegocio:'',
      })
      console.log("Aqui es...")
      console.log(objj);


       

    
 
    

}

onChangeGiro(GIRO) {
  console.log(GIRO);

let { Giro} = this.state;

let newOption = GIRO

this.setState({
  value3: newOption,  
  Giro: [...Giro],
  otro: Giro.filter(tipo => tipo.GIRO.toLowerCase().includes(GIRO.GIRO.toLowerCase()))
})
}

onChangeFechaRegistro(e) {
  this.setState({
  NoFolio: e.target.value.toUpperCase()
  });
  }
  onChangeNoFolio(e) {
  this.setState({
  NoFolio: e.target.value.toUpperCase()
  });
  }
  onChangeNoOficio(e) {
  this.setState({
  NoOficio: e.target.value.toUpperCase()
  }) 
  }
  onChangeEstatusActual(e) {
  this.setState({
  EstatusActual: e.target.value.toUpperCase()
  })
  }
  onChangeAsuntos(e) {
  this.setState({
  Asuntos: e.target.value.toUpperCase()
  })
  }
  onChangeObservaciones(e) {
  this.setState({
  Observaciones: e.target.value.toUpperCase()
  })
  }
  onChangenombre(e) {
  this.setState({
  nombre: e.target.value.toUpperCase()
  });
  }
  onChangedomicilio(e) {
  this.setState({
  domicilio: e.target.value.toUpperCase()
  });
  }
  onChangetelefono(e) {
  this.setState({
  telefono: e.target.value.toUpperCase()
  });
  }
  onChangeEmisor(e) {
  this.setState({
  Emisor: e.target.value.toUpperCase()
  })
  }
  onChangeFechaDocumento(e) {
  this.setState({
  FechaDocumento: e.target.value.toUpperCase()
  }) 
  }

  onChangemedidas(e) {
    this.setState({
    medidas: e.target.value.toUpperCase()
    });
    }
    onChangeAforo(e) {
      this.setState({
      Aforo: e.target.value.toUpperCase()
      });
      }
      onChangerazonsocial(e) {
        this.setState({
        razonsocial: e.target.value.toUpperCase()
        });
        }
        onChangeclavecatastral(e) {
          this.setState({
          clavecatastral: e.target.value.toUpperCase()
          });
          }

  /*
onChangenombreNegocio(e) {
        this.setState({
        nombreNegocio: e.target.value.toUpperCase()
        });
        }
        onChangetelefonoNegocio(e) {
          this.setState({
          telefonoNegocio: e.target.value.toUpperCase()
          });
          }
  */
  onChangeFechaExpiracion(e) {
  this.setState({
  FechaExpiracion: e.target.value.toUpperCase()
  }) 
  }
  onChangeCEstadoCivil(descripcion) {
    console.log(descripcion);
    let { Categorias} = this.state;
    
    let newOption = descripcion;
    
    this.setState({
    value: newOption, 
    Categorias: [...Categorias],
    otro: Categorias.filter(tipo => tipo.descripcion.toLowerCase().includes(descripcion.descripcion.toLowerCase()))
    })
    }
  onChangePersona(e) {
  this.setState({
  Persona: e.target.value.toUpperCase()
  }) 
  }

  onChangerfc(e) {
  this.setState({
  rfc: e.target.value.toUpperCase()
  }) 
  }
  onChangecorreo(e) {
  this.setState({
  correo: e.target.value.toUpperCase()
  }) 
  }
  onChangeapoderado(e) {
  this.setState({
  apoderado: e.target.value.toUpperCase()
  }) 
  }
  onChangecalle(e) {
  this.setState({
  calle: e.target.value.toUpperCase()
  }) 
  }
  onChangeentreCalle(e) {
  this.setState({
  entreCalle: e.target.value.toUpperCase()
  }) 
  }
  onChangeyCalle(e) {
  this.setState({
  yCalle: e.target.value.toUpperCase()
  }) 
  }
  onChangeno(e) {
  this.setState({
  no: e.target.value.toUpperCase()
  }) 
  }
  onChangecolonia(e) {
  this.setState({
  colonia: e.target.value.toUpperCase()
  }) 
  }
  onChangecodigoPostal(e) {
  this.setState({
  codigoPostal: e.target.value.toUpperCase()
  }) 
  }
  onChangelocalidad(e) {
  this.setState({
  localidad: e.target.value.toUpperCase()
  }) 
  }

 
  onChangeinversion(e) {
  this.setState({
  inversion: e.target.value.toUpperCase()
  }) 
  }
  onChangeobservaciones(e) {
  this.setState({
  observaciones: e.target.value.toUpperCase()
  }) 
  }
  onChangedenominacionComercial(e) {
  this.setState({
  denominacionComercial: e.target.value.toUpperCase()
  }) 
  }
  onChangetipoEstablecimiento(e) {
  this.setState({
  tipoEstablecimiento: e.target.value.toUpperCase()
  }) 
  }

  onChangeemp_recolectora(e) {
    this.setState({
    emp_recolectora: e.target.value.toUpperCase()
    }) 
    }
    onChangeticket_recolector(e) {
      this.setState({
      ticket_recolector: e.target.value.toUpperCase()
      }) 
      }
      onChangerazons_recolector(e) {
        this.setState({
        razons_recolector: e.target.value.toUpperCase()
        }) 
        }
        onChangepapel_dia(e) {
          this.setState({
          papel_dia: e.target.value.toUpperCase()
          }) 
          }
          onChangepapel_sem(e) {
            this.setState({
            papel_sem: e.target.value.toUpperCase()
            }) 
            }
            onChangepapel_mes(e) {
              this.setState({
              papel_mes: e.target.value.toUpperCase()
              }) 
              }
              onChangeplastico_dia(e) {
                this.setState({
                plastico_dia: e.target.value.toUpperCase()
                }) 
                }
                onChangeplastico_sem(e) {
                  this.setState({
                  plastico_sem: e.target.value.toUpperCase()
                  }) 
                  }
                  onChangeplastico_mes(e) {
                    this.setState({
                    plastico_mes: e.target.value.toUpperCase()
                    }) 
                    }
                    onChangevidrio_dia(e) {
                      this.setState({
                      vidrio_dia: e.target.value.toUpperCase()
                      }) 
                      }
                      onChangevidrio_sem(e) {
                        this.setState({
                        vidrio_sem: e.target.value.toUpperCase()
                        }) 
                        }
                        onChangevidrio_mes(e) {
                          this.setState({
                          vidrio_mes: e.target.value.toUpperCase()
                          }) 
                          }
                          onChangecarton_dia(e) {
                            this.setState({
                            carton_dia: e.target.value.toUpperCase()
                            }) 
                            }
                            onChangecarton_sem(e) {
                              this.setState({
                              carton_sem: e.target.value.toUpperCase()
                              }) 
                              }
                              onChangecarton_mes(e) {
                                this.setState({
                                carton_mes: e.target.value.toUpperCase()
                                }) 
                                }
                                onChangeorganico_dia(e) {
                                  this.setState({
                                  organico_dia: e.target.value.toUpperCase()
                                  }) 
                                  }
                                  onChangeorganico_sem(e) {
                                    this.setState({
                                    organico_sem: e.target.value.toUpperCase()
                                    }) 
                                    }
                                    onChangeorganico_mes(e) {
                                      this.setState({
                                      organico_mes: e.target.value.toUpperCase()
                                      }) 
                                      }
                                      onChangeotros_dia(e) {
                                        this.setState({
                                        otros_dia: e.target.value.toUpperCase()
                                        }) 
                                        }
                                        onChangeotros_sem(e) {
                                          this.setState({
                                          otros_sem: e.target.value.toUpperCase()
                                          }) 
                                          }
                                          onChangeotros_mes(e) {
                                            this.setState({
                                            otros_mes: e.target.value.toUpperCase()
                                            }) 
                                            }
                                            onChangeob_papel(e) {
                                              this.setState({
                                              ob_papel: e.target.value.toUpperCase()
                                              }) 
                                              }
                                              onChangeob_plastico(e) {
                                                this.setState({
                                                ob_plastico: e.target.value.toUpperCase()
                                                }) 
                                                }onChangeob_vidrio(e) {
                                                  this.setState({
                                                  ob_vidrio: e.target.value.toUpperCase()
                                                  }) 
                                                  }
                                                  onChangeob_carton(e) {
                                                    this.setState({
                                                    ob_carton: e.target.value.toUpperCase()
                                                    }) 
                                                    }
                                                    onChangeob_organico(e) {
                                                      this.setState({
                                                      ob_organico: e.target.value.toUpperCase()
                                                      }) 
                                                      }
                                                      onChangeob_otros(e) {
                                                        this.setState({
                                                        ob_otros: e.target.value.toUpperCase()
                                                        }) 
                                                        }
                                                        onChangeCMatricula(e) {
                                                          this.setState({
                                                          CMatricula: e.target.value.toUpperCase()
                                                          })
                                                          }
                                                          onChangeCApellidoPaterno(e) {
                                                            this.setState({
                                                              CApellidoPaterno: e.target.value.toUpperCase()
                                                            })
                                                            }
                                                            onChangeCApellidoMaterno(e) {
                                                              this.setState({
                                                                CApellidoMaterno: e.target.value.toUpperCase()
                                                              })
                                                              }
                                                              onChangeCNombre(e) {
                                                                this.setState({
                                                                  CNombre: e.target.value.toUpperCase()
                                                                })
                                                                }
                                                                onChangeCFechaNacimiento(e) {
                                                                  this.setState({
                                                                    CFechaNacimiento: e.target.value.toUpperCase()
                                                                  })
                                                                  }
                                                                  onChangeCClase(e) {
                                                                    const value = e.target.value.toUpperCase();
                                                                  
                                                                    // Limitar a 4 caracteres
                                                                    if (value.length <= 4) {
                                                                      this.setState({
                                                                        CClase: value,
                                                                      });
                                                                    }
                                                                  }
                                                                onChangeCLugarNacimiento(e) {
                                                                  this.setState({
                                                                    CLugarNacimiento: e.target.value.toUpperCase()
                                                                  })
                                                                  }
                                                                  onChangeCNombrePadre(e) {
                                                                    this.setState({
                                                                      CNombrePadre: e.target.value.toUpperCase()
                                                                    })
                                                                    }onChangeCNombreMadre(e) {
                                                                      this.setState({
                                                                        CNombreMadre: e.target.value.toUpperCase()
                                                                      })
                                                                      }onChangeCTutor(e) {
                                                                        this.setState({
                                                                          CTutor: e.target.value.toUpperCase()
                                                                        })
                                                                        }onChangeCOcupacion(e) {
                                                                          this.setState({
                                                                            COcupacion: e.target.value.toUpperCase()
                                                                          })
                                                                        }onChangeCLeerEscribir(e) {
                                                                          this.setState({
                                                                            CLeerEscribir: e.target.value.toUpperCase()
                                                                          })
                                                                        }onChangeCCurp(e) {
                                                                          const inputValue = e.target.value.toUpperCase();
                                                                          const maxLength = 18;
                                                                          const trimmedValue = inputValue.slice(0, maxLength); // Recorta el valor a 18 caracteres como máximo
                                                                          this.setState({ CCurp: trimmedValue });
                                                                        }
                                                                        onChangeCNivelEstudios(e) {
                                                                          this.setState({
                                                                            CNivelEstudios: e.target.value.toUpperCase()
                                                                          })
                                                                        }onChangeCGradoMaximo(e) {
                                                                          this.setState({
                                                                            CGradoMaximo: e.target.value.toUpperCase()
                                                                          })
                                                                        }onChangeCDomicilio(e) {
                                                                          this.setState({
                                                                            CDomicilio: e.target.value.toUpperCase()
                                                                          })
                                                                        }onChangeCFechaEntrega(e) {
                                                                          this.setState({
                                                                            CFechaEntrega: e.target.value.toUpperCase()
                                                                          })
                                                                         } onChangeCFechaRegistro(e) {
                                                                            this.setState({
                                                                              CFechaRegistro: e.target.value.toUpperCase()
                                                                            })
                                                                          }




  onSubmit(e) {
  e.preventDefault();
  //let nfn =this.fechaNombre(this.state.CFechaNacimiento);
  //let nfe =this.fechaNombre(this.state.CFechaEntrega);
    // en el obj solo metele los datos q se van a editar
    const obj = {
     id_preregistro:this.props.obj.id_preregistro,
     // matricula: this.state.CMatricula,
      ap_paterno: this.state.CApellidoPaterno,
      ap_materno: this.state.CApellidoMaterno,
      nombre: this.state.CNombre,
      fecha_nac: this.state.CFechaNacimiento,
     // clase: this.state.CClase,
      lugar_nac: this.state.CLugarNacimiento,
      nombre_padre: this.state.CNombrePadre,
      nombre_madre: this.state.CNombreMadre,
      tutor: this.state.CTutor,
      estado_civil: this.state.value.descripcion,
      ocupacion: this.state.COcupacion,
      leer_escribir: this.state.CLeerEscribir,
      CURP: this.state.CCurp,
      nivel_estudios: this.state.CNivelEstudios,
      grado: this.state.CGradoMaximo,
      domicilio: this.state.CDomicilio,
    //  fecha_entrega: this.state.CFechaEntrega,
     // nfecha_entrega: nfe,
     // nfecha_nac: nfn,
  
    };

    
console.log(obj)
UPDPreregistro(obj).then(response => {


      console.log(response);
      if(response=="Cliente modificado."){
      alert("Cartilla Actualizada!");
    this.props.onR();
    }
    }).catch(err => console.log(err));
    
  
  }


onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
};



fechaNombre(fecha){
let fN=fecha.substring(0,10);
let fnn="";

let af=fN.split("-");

fnn=af[2]+" DE ";

if(af[1]=="01"){
  fnn=fnn+"ENERO DE "
}else if(af[1]=="02"){
  fnn=fnn+"FEBRERO DE "
}
else if(af[1]=="03"){
  fnn=fnn+"MARZO DE "
}
else if(af[1]=="04"){
  fnn=fnn+"ABRIL DE "
}
else if(af[1]=="05"){
  fnn=fnn+"MAYO DE "
}
else if(af[1]=="06"){
  fnn=fnn+"JUNIO DE "
}
else if(af[1]=="07"){
  fnn=fnn+"JULIO DE "
}
else if(af[1]=="08"){
  fnn=fnn+"AGOSTO DE "
}
else if(af[1]=="09"){
  fnn=fnn+"SEPTIEMBRE DE "
}
else if(af[1]=="10"){
  fnn=fnn+"OCTUBRE DE "
}
else if(af[1]=="11"){
  fnn=fnn+"NOVIEMBRE DE "
}
else if(af[1]=="12"){
  fnn=fnn+"DICIEMBRE DE "
}

fnn=fnn+af[0];
return fnn;
}

  render() {
    let { value3,Giro} = this.state;

    let bloqueado;

    if(this.props.userLG!=453){
      bloqueado = 'readOnly';
    }
    let { value, Categorias, value2, Emisor, Persona} = this.state;
    
    let fecha;
    if(this.state.FechaExpiracion == null || this.state.FechaExpiracion == ""){
      fecha= <input 
      type="date" 
      required
      className="form-control" 
      value={this.state.FechaExpiracion}
      onChange={this.onChangeFechaExpiracion}
     
     
     
      />
      
    }
    else{
      fecha= <input 
      type="text" 
      disabled
      required
      className="form-control" 
      value={this.state.FechaExpiracion}
      onChange={this.onChangeFechaExpiracion}
     
     
     
      />
    }
    

    
  return (
    <div style={{ marginTop: 10 }}>
        
        <form onSubmit={this.onSubmit}>
          
       
            <div className="form-group" style={{padding:'65px'}}>
            <h4 align="center" > <EmisorIcon extendedIcon /> &nbsp;DATOS DE LA PERSONA   </h4> 
              <hr></hr>
            <Grid container spacing={2} >

            <Grid item xs={4}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE(S) </label>
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                type="text" 
                required
                readOnly={this.props.tipo==1 ? false : true}

                  className="form-control"
                  value={this.state.CNombre}
                  onChange={this.onChangeCNombre}
                  />
            </div>
            </Grid>

                  <Grid item xs={4}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO PATERNO </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                required
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CApellidoPaterno}
                  onChange={this.onChangeCApellidoPaterno}
                  />
            </div>
            </Grid>
            <Grid item xs={4}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO MATERNO </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                required
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CApellidoMaterno}
                  onChange={this.onChangeCApellidoMaterno}
                  />
            </div>
            </Grid>
            
             </Grid>
             <Grid container spacing={2} >
                <Grid item xs={4}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>FECHA DE NACIMIENTO </label>
                <input type="date" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                required
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}
                  max={`${new Date().getFullYear()}-12-31`}
                  value={this.state.CFechaNacimiento}
                  onChange={this.onChangeCFechaNacimiento}
                  />
                  </Grid>

                 
            <Grid item xs={6}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>LUGAR DE NACIMIENTO </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                required
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CLugarNacimiento}
                  onChange={this.onChangeCLugarNacimiento}
                  />
            </div>
            </Grid>
            <Grid item xs={6}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE DEL PADRE </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CNombrePadre}
                  onChange={this.onChangeCNombrePadre}
                  />
            </div>
            </Grid>
            <Grid item xs={6}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE DE LA MADRE </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CNombreMadre}
                  onChange={this.onChangeCNombreMadre}
                  />
            </div>
            </Grid>
            <Grid item xs={6}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>TUTOR SI LO TIENE </label>
                <input type="text" 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  readOnly={this.props.tipo==1 ? false : true}

                  value={this.state.CTutor}
                  onChange={this.onChangeCTutor}
                  />
            </div>
            </Grid>
                 
                <Grid item xs={3}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>ESTADO CIVIL </label>
                <DropdownList 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px', width:'100%'}}
                required
                filter
                        data={Categorias}
                        value={value}
                        allowCreate="onFilter"
                        readOnly={this.props.tipo==1 ? false : true}

                      
                        onChange={descripcion => this.onChangeCEstadoCivil(descripcion)}
                        textField="descripcion"
                        placeholder="ESTADO CIVIL..."
                      />                 
                </Grid>
                <Grid item xs={3}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>OCUPACIÓN </label>
             
    <DropdownList
      readOnly={this.props.tipo==1 ? false : true}
     value={this.state.COcupacion}      
    onChange={(nextValue) => this.setState({COcupacion:nextValue})}
      data={this.state.oE}
    />   
            </div>
            </Grid>
            <Grid item xs={2}>
        <div className="form-group">
        <label style={{color:'#5B6B79',fontSize:'14px'}}>SABE LEER Y ESCRIBIR </label>
                <RadioGroup aria-label="emp_recolectora" name="emp_recolectora" value={this.state.CLeerEscribir} onChange={this.onChangeCLeerEscribir} >
      <FormControlLabel value="SI" control={<Radio />} label="SI" />
      <FormControlLabel value="NO" control={<Radio />} label="NO" />
      
  
    </RadioGroup>
            </div>
            </Grid>
            <Grid item xs={4}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>CURP </label>
                <input type="text" 
                                readOnly={this.props.tipo==1 ? false : true}

                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  value={this.state.CCurp}
                  onChange={this.onChangeCCurp}
                  />
            </div>
            </Grid>
            <Grid item xs={4}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>NIVEL MÁXIMO DE ESTUDIOS </label>
       
                  <DropdownList
                                  readOnly={this.props.tipo==1 ? false : true}

      value={this.state.CNivelEstudios}
      onChange={(nextValue) => this.setState({CNivelEstudios:nextValue})}
      data={this.state.nivelE}
    />
            </div>
            </Grid>
            <Grid item xs={2}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>GRADO MÁXIMO </label>
                <input type="text" 
                                readOnly={this.props.tipo==1 ? false : true}

                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  value={this.state.CGradoMaximo}
                  onChange={this.onChangeCGradoMaximo}
                  />
            </div>
            </Grid>

            <Grid item xs={10}>
            <div className="form-group">
            <label style={{color:'#5B6B79',fontSize:'14px'}}>DOMICILIO </label>
                <input type="text" 
                readOnly={this.props.tipo==1 ? false : true}
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  className="form-control"
                  value={this.state.CDomicilio}
                  onChange={this.onChangeCDomicilio}
                  />
            </div>
            </Grid>



            
                </Grid>

                <hr></hr>

                <div className="form-group">
                 {this.props.tipo==1 ?   <input style={{borderRadius:'40px',float:'right'}} type="submit" value="ACTUALIZAR" className="btn btn-success"/> : null} 
                
              </div>
            </div>
            {}
            <Grid container spacing={2} >
           
          
                  </Grid>
                  
            </form>
        </div>
    )
  }
}